import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteEmploymentStatus, getAllEmploymentStatuses,createEmploymentStatus,editEmploymentStatus } from '../../api/axiosEmploymentStatuses';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';







const EmploymentStatuses = () => {
  const { employmentStatuses, setEmploymentStatuses, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [editedEmploymentStatus, setEditedEmploymentStatus] = useState("");
  


 

  const NewTitle = "All Employment Statuses";
  useEffect(() => {
    
    getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
    
  }, []);


  const filteredEmploymentStatuses = employmentStatuses.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()));
  const filteredReversedEmploymentStatuses = filteredEmploymentStatuses.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setEmploymentStatuses, setFetcherror, handleAllToasts) => {
    return () => {
      deleteEmploymentStatus(pkid, setEmploymentStatuses, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this EmploymentStatus?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedEmploymentStatus(foundItem?.name);
   
   }

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          
          <SearchToolBar
                    setAddItemDialogVisible={setAddItemDialogVisible}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    searchPlaceholder="Status"
                    createLabel="Status"
          />
        <DataTable
          value={filteredEmploymentStatuses}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No employment Status found"
        >
                    <Column header="S/N" body={(rowData) => employmentStatuses.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Name"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                          <TableActions
                            id={rowData.id}
                            data={employmentStatuses}
                            getItemtoEdit={getItemtoEdit}
                            setSelectedId={setSelectedId}
                            setEditDialogVisible={setEditDialogVisible}
                            setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New EmploymentStatus" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createEmploymentStatus(employmentStatus, setEmploymentStatus, setFetcherror, handleAllToasts, setEmploymentStatuses);
                if (employmentStatus) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter EmploymentStatus Name"
                    value={employmentStatus}
                    onChange={(e) => setEmploymentStatus(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setEmploymentStatus("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit EmploymentStatus" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editEmploymentStatus( selectedId, editedEmploymentStatus, setEditedEmploymentStatus,  setFetcherror, handleAllToasts, setEmploymentStatuses);
                if (editedEmploymentStatus) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter EmploymentStatus Name"
                    value={editedEmploymentStatus}
                    onChange={(e) => setEditedEmploymentStatus(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setEmploymentStatus("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setEmploymentStatuses, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default EmploymentStatuses


